export { SocialPlatformIcon } from './SocialPlatformIcon';
